export const recommendData = [
  {
    id: 1,
    place: "Kathmandu Valley",
    description:
      "Bursting at the seams with ancient palaces, sacred temples, and colorful bazaars, Kathmandu boasts a rich cultural heritage.",
    imageUrl: "/assets/recommended/kathmandu.jpeg",
    attractions: [
      {
        id: 10,
        place: "Kathmandu Durbar Square",
        description:
          "Kathmandu Durbar Square, nestled in the heart of Kathmandu city, stands as a testament to Nepal's rich cultural and historical legacy. This historic plaza, steeped in centuries of tradition, serves as a vibrant hub where the past seamlessly intertwines with the present. Adorned with a myriad of architectural marvels, Kathmandu Durbar Square mesmerizes visitors with its grandeur and charm. At the heart of Kathmandu Durbar Square lie majestic palaces, each bearing the imprint of ancient dynasties that once ruled the Kathmandu Valley. These palaces, with their intricate carvings and ornate facades, offer a glimpse into the opulent lifestyles of Nepal's erstwhile monarchs. Among them stands the imposing Hanuman Dhoka Palace, a sprawling complex that served as the royal residence of the Malla kings. Its sprawling courtyards and regal halls echo with tales of bygone eras, inviting visitors to immerse themselves in the splendor of Nepal's royal heritage.",
        imageUrl: [
          {
            url: "/assets/recommended/kathmandu1.png",
            id: 1,
          },
          {
            url: "/assets/recommended/kathmandu2.jpeg",
            id: 2,
          },
        ],
      },

      {
        id: 8,
        place: "Pashupatinath Temple",
        description:
          "Pashupatinath Temple, nestled along the serene banks of the Bagmati River, stands as a beacon of Hindu spirituality and devotion in the heart of Nepal. Revered as one of the most sacred sites in the country, this ancient temple is dedicated to Lord Shiva, the supreme deity of the Hindu pantheon. Its hallowed grounds have drawn pilgrims and seekers from far and wide, seeking blessings, solace, and spiritual enlightenment. With its rich historical significance and architectural grandeur, Pashupatinath Temple is a testament to Nepal's profound religious heritage. The temple complex is a sprawling labyrinth of shrines, courtyards, and sacred structures, each intricately adorned with ornate carvings and vibrant religious iconography. Amidst the bustling atmosphere of devotion, devotees gather to offer prayers, perform rituals, and seek divine intervention in their lives.",
        imageUrl: [
          {
            url: "/assets/recommended/pashupati1.jpeg",
            id: 1,
          },
          // {
          //   url: "/assets/recommended/pashupati2.webp",
          //   id: 2,
          // },
        ],
      },

      {
        id: 9,
        place: "Swayambhunath Stupa",
        description:
          "Swayambhunath Stupa, affectionately known as the Monkey Temple, stands as a timeless symbol of spiritual enlightenment atop a verdant hill in the Kathmandu Valley. Revered as one of the oldest and most sacred Buddhist sites in Nepal, this ancient religious complex holds a special place in the hearts of pilgrims and travelers alike. Perched majestically on a hillside, Swayambhunath offers panoramic views of the Kathmandu skyline, serving as a serene sanctuary amidst the hustle and bustle of city life. Its iconic white dome, adorned with the watchful eyes of the Buddha, gazes out over the valley, offering blessings and protection to all who seek solace within its sacred precincts. As visitors ascend the stone steps to the stupa, they are greeted by a vibrant tapestry of prayer flags fluttering in the breeze, their colorful hues symbolizing the aspirations and prayers of devotees. The air is filled with the melodious chants of Buddhist hymns, creating a sense of tranquility and reverence that permeates the atmosphere.",
        imageUrl: [
          {
            url: "/assets/recommended/swayambhunath1.jpeg",
            id: 1,
          },
          {
            url: "/assets/recommended/swayambhunath2.jpeg",
            id: 2,
          },
          {
            url: "/assets/recommended/swayambhunath3.jpeg",
            id: 3,
          },
        ],
      },

      {
        id: 11,
        place: "Patan Durbar Square",
        description:
          "Patan Durbar Square, a UNESCO World Heritage Site nestled in the heart of Patan city, beckons visitors with its captivating blend of history, culture, and architectural splendor. Stepping into this ancient plaza feels like embarking on a journey through time, as centuries-old palaces, temples, and courtyards bear witness to the rich legacy of the Malla dynasty. Majestic pagoda-style temples rise proudly against the sky, their intricate woodcarvings and delicate metalwork showcasing the craftsmanship of Newari artisans. The iconic Krishna Mandir, dedicated to Lord Krishna, stands as a testament to the city's devotion to Hindu deities, its ornate facade adorned with scenes from the epic Mahabharata. As visitors wander through the labyrinthine alleyways of the square, they encounter hidden treasures at every turn, from intricately carved stone water spouts to ancient shrines steeped in myth and legend. At the center of it all stands the imposing Patan Museum, a bastion of cultural heritage that houses a priceless collection of artifacts, sculptures, and religious icons. Here, amidst the timeless beauty of Patan Durbar Square, the past and present converge, inviting travelers to immerse themselves in the rich tapestry of Nepal's architectural and artistic heritage.",
        imageUrl: [
          {
            url: "/assets/recommended/patan1.jpeg",
            id: 1,
          },
          {
            url: "/assets/recommended/patan2.jpeg",
            id: 2,
          },
          {
            url: "/assets/recommended/patan3.jpeg",
            id: 3,
          },
        ],
      },
      {
        id: 13,
        place: "Bhaktapur Durbar Square",
        description:
          "Bhaktapur Durbar Square, a UNESCO World Heritage Site nestled in the heart of Bhaktapur city, offers a mesmerizing journey through Nepal's storied past. This historic plaza serves as a living testament to the city's rich cultural heritage, with its magnificent palaces, temples, and statues bearing witness to centuries of artistic and architectural excellence. As visitors traverse the cobblestone pathways of the square, they are transported back in time to an era of royal grandeur and religious devotion. The iconic Nyatapola Temple, with its towering pagoda roof and intricate woodcarvings, stands as a symbol of Bhaktapur's reverence for the divine. Surrounding the temple, ancient courtyards and marketplaces bustle with life, their vibrant colors and bustling energy reflecting the city's vibrant spirit. At every corner, hidden treasures await discovery, from ornate stone sculptures to intricately carved doorways that tell tales of bygone eras. Amidst the hustle and bustle of Bhaktapur Durbar Square, visitors can immerse themselves in the timeless beauty of Nepal's cultural heritage, where the echoes of history resonate with every step.",
        imageUrl: [
          {
            url: "/assets/recommended/bhaktapur1.jpeg",
            id: 1,
          },
          // {
          //   url: "/assets/recommended/bhaktapur2.webp",
          //   id: 2,
          // },
        ],
      },
      {
        id: 15,
        place: "Boudhanath Stupa",
        description:
          "Boudhanath Stupa, also known as the Boudha Stupa, stands as a serene sanctuary of peace and spirituality amidst the bustling streets of Kathmandu Valley. This ancient Buddhist pilgrimage site exudes a sense of tranquility and reverence, drawing pilgrims and tourists alike from across the globe. As one approaches the stupa, its majestic white dome adorned with vibrant prayer flags commands attention, serving as a beacon of enlightenment and harmony. Encircling the stupa, a bustling market bustles with activity, offering a kaleidoscope of sights, sounds, and scents that awaken the senses. Visitors can partake in the age-old tradition of circumambulating the stupa, spinning prayer wheels and offering prayers for blessings and prosperity. The air is filled with the soothing chants of monks and the fragrance of incense, creating an atmosphere conducive to introspection and contemplation. At sunset, the stupa is bathed in a warm golden light, casting a tranquil glow over the surrounding landscape. As one gazes upon the Boudhanath Stupa, it serves as a reminder of the enduring power of faith and the timeless pursuit of inner peace.",
        imageUrl: [
          {
            url: "/assets/recommended/boudha1.jpeg",
            id: 1,
          },
          {
            url: "/assets/recommended/boudha2.jpeg",
            id: 2,
          },
          {
            url: "/assets/recommended/boudha3.jpeg",
            id: 3,
          },
        ],
      },
      {
        id: 7,
        place: "Dwarika Hotel",
        description:
          "Dwarika Hotel epitomizes luxury and cultural heritage, offering guests an unparalleled experience steeped in tradition and elegance. Nestled in the heart of Kathmandu, this 5-star hotel is renowned for its distinctive Newari architecture, which seamlessly blends ancient craftsmanship with modern comforts. Each corner of the hotel exudes a sense of opulence and refinement, from its intricately carved wooden pillars to its ornate courtyards adorned with lush gardens and tranquil fountains. As guests step into Dwarika Hotel, they are transported to a bygone era of regal splendor and gracious hospitality. The hotel's spacious accommodations are tastefully furnished with traditional Nepali decor, offering a luxurious retreat from the bustling city outside. Whether relaxing in the comfort of their rooms or exploring the hotel's myriad facilities, guests are enveloped in an atmosphere of tranquility and indulgence.",
        imageUrl: [
          {
            url: "/assets/recommended/dwarika1.jpeg",
            id: 1,
          },
          {
            url: "/assets/recommended/dwarika2.jpeg",
            id: 2,
          },
        ],
      },
    ],
  },
  {
    id: 2,
    place: "Everest Region",
    description:
      "Explore the breathtaking Everest Region, home to the world's tallest peak and stunning mountain vistas.",
    imageUrl: "/assets/recommended/everest.jpeg",
    attractions: [
      {
        id: 11,
        place: "Sagarmatha National Park",
        description:
          "Sagarmatha National Park, located in the Everest region, is a UNESCO World Heritage Site that boasts some of the most breathtaking natural scenery on Earth. Dominated by the towering peak of Mount Everest, the park is a haven for trekkers, climbers, and nature enthusiasts. The park is home to a diverse array of flora and fauna, including rare species like the snow leopard and the red panda. The landscape is a dramatic mix of deep valleys, glaciers, and high-altitude peaks, offering an unparalleled adventure for those who dare to explore its rugged beauty. The Sherpa culture is an integral part of the region, and visitors can experience their unique way of life by visiting traditional villages.",
        imageUrl: [
          {
            url: "/assets/recommended/sagarmatha1.jpeg",
            id: 1,
          },
          {
            url: "/assets/recommended/sagarmatha2.jpeg",
            id: 2,
          },
        ],
      },
      {
        id: 12,
        place: "Tengboche Monastery",
        description:
          "Tengboche Monastery, perched high in the Everest region, is one of the most significant spiritual centers for Tibetan Buddhism in Nepal. With Mount Everest and other Himalayan peaks as its backdrop, the monastery offers a serene and majestic atmosphere for meditation and reflection. Tengboche Monastery is renowned for its vibrant Mani Rimdu festival, which features masked dances and colorful rituals that draw both locals and tourists alike. The monastery itself is an architectural marvel, adorned with intricate murals and statues that reflect the rich cultural heritage of the region. Visitors can experience the tranquility and spiritual depth of this sacred place, which has been a beacon of peace and enlightenment for centuries.",
        imageUrl: [
          {
            url: "/assets/recommended/teng1.jpeg",
            id: 1,
          },
          {
            url: "/assets/recommended/teng2.jpeg",
            id: 2,
          },
        ],
      },
    ],
  },
  {
    "id": 3,
    "place": "Pokhara",
    "description": "Nestled amidst the Himalayas, Pokhara is a serene city blessed with tranquil lakes, lush forests, and majestic mountain views.",
    "imageUrl": "/assets/recommended/sarang1.jpeg",
    "attractions": [
      {
        "id": 1,
        "place": "Phewa Lake",
        "description": "Phewa Lake is the second-largest lake in Nepal and a popular spot for boating and sightseeing. It offers stunning reflections of the surrounding mountains and is home to the Tal Barahi Temple. Visitors can rent colorful paddle boats or take a leisurely stroll along the lakeside, enjoying the tranquil atmosphere and picturesque scenery. The lake is surrounded by lush forests and hills, providing a perfect backdrop for photography. The serene waters and the view of the Annapurna range make Phewa Lake a must-visit destination in Pokhara.",
        "imageUrl": [
          { "url": "/assets/recommended/phewa4.jpeg", "id": 4 },
          { "url": "/assets/recommended/phewa3.jpeg", "id": 3 },
          { "url": "/assets/recommended/phewa2.jpeg", "id": 4 }
        ]
      },
      {
        "id": 2,
        "place": "Sarangkot",
        "description": "Sarangkot is famous for its panoramic views of the Annapurna and Dhaulagiri ranges, especially at sunrise and sunset. It's also a top spot for paragliding. The viewpoint at Sarangkot offers a breathtaking vista of the snow-capped mountains, rolling hills, and the Pokhara Valley below. Early risers can witness the spectacular sunrise, with the first light illuminating the peaks in a golden hue. Adventure enthusiasts can take advantage of the ideal paragliding conditions, soaring above the landscape and experiencing the thrill of flight. Sarangkot is accessible by a short drive from Pokhara, followed by a brief hike to the summit.",
        "imageUrl": [
          { "url": "/assets/recommended/sarang1.jpeg", "id": 1 },
          { "url": "/assets/recommended/sarang2.jpeg", "id": 2 },
          { "url": "/assets/recommended/sarang3.jpeg", "id": 2 }
        ]
      },
      {
        "id": 3,
        "place": "Devi's Fall",
        "description": "Devi's Fall is a spectacular waterfall that flows into an underground tunnel, offering a unique and awe-inspiring sight. Known locally as Patale Chhango, the waterfall is named after a Swiss visitor who was swept away by the waters. The falls create a powerful and mesmerizing cascade, disappearing into the depths of the earth. Nearby, visitors can explore the Gupteshwor Mahadev Cave, which is directly opposite the falls and features a shrine dedicated to Lord Shiva. The combination of the roaring waterfall and the mystical cave creates a captivating experience for all who visit.",
        "imageUrl": [
          { "url": "/assets/recommended/devisfall1.jpeg", "id": 1 },
          { "url": "/assets/recommended/devisfall2.jpeg", "id": 2 }
        ]
      },
      {
        "id": 4,
        "place": "Peace Pagoda",
        "description": "The World Peace Pagoda in Pokhara offers serene surroundings and stunning views of the city, lake, and mountains. Perched atop a hill on the southern shore of Phewa Lake, the pagoda is a symbol of peace and harmony. Visitors can hike or drive to the site, where they are greeted by the magnificent white stupa and beautifully landscaped gardens. The panoramic views from the pagoda encompass the Annapurna range, Phewa Lake, and the sprawling Pokhara Valley. The tranquil environment and spiritual ambiance make the Peace Pagoda an ideal place for meditation and reflection.",
        "imageUrl": [
          { "url": "/assets/recommended/peace1.jpeg", "id": 1 },
          { "url": "/assets/recommended/peace2.jpeg", "id": 2 },
          // { "url": "/assets/recommended/peace3.webp", "id": 3 }
        ]
      },
      {
        "id": 5,
        "place": "Begnas Lake",
        "description": "Begnas Lake is a tranquil spot ideal for boating and fishing, surrounded by lush hills and offering a peaceful ambiance. Located about 15 kilometers east of Pokhara, Begnas Lake is less crowded than Phewa Lake, providing a more serene and secluded experience. The calm waters are perfect for boating, and the surrounding hills offer excellent opportunities for hiking and exploring nature. The lake is also popular among anglers, with various species of fish inhabiting its waters. The picturesque scenery and quiet atmosphere make Begnas Lake a perfect retreat for those seeking relaxation and natural beauty.",
        "imageUrl": [
          { "url": "/assets/recommended/begnas1.jpeg", "id": 1 },
          { "url": "/assets/recommended/begnas2.jpeg", "id": 2 },
          { "url": "/assets/recommended/begnas3.jpeg", "id": 3 }
        ]
      }
    ]
  },
  

  {
    "id": 4,
    "place": "Chitwan National Park",
    "description": "Immerse yourself in the natural beauty of Chitwan National Park, where you can encounter diverse wildlife in their natural habitat.",
    "imageUrl": "/assets/recommended/chitwan.jpeg",
    "attractions": [
      {
        "id": 1,
        "place": "Jungle Safari",
        "description": "Experience the thrill of a jungle safari in Chitwan National Park, home to tigers, rhinoceros, and a variety of other wildlife. The safari takes you deep into the heart of the park, where you can witness these magnificent creatures in their natural environment. Guided by experienced naturalists, the safari provides a unique opportunity to learn about the rich biodiversity of the region and the conservation efforts in place to protect these species. Whether by jeep or on foot, the jungle safari offers an unforgettable adventure filled with exciting wildlife sightings and the chance to connect with nature.",
        "imageUrl": [
          { "url": "/assets/recommended/c1.jpeg", "id": 1 },
          { "url": "/assets/recommended/c2.jpeg", "id": 2 }
        ]
      },
      {
        "id": 2,
        "place": "Elephant Breeding Center",
        "description": "Visit the Elephant Breeding Center to learn about these majestic animals and see baby elephants up close. The center is dedicated to the conservation and breeding of elephants, providing a safe haven for these gentle giants. Visitors can observe the daily routines of the elephants, including feeding and bathing, and gain insights into their behavior and care. The center also educates the public about the importance of elephant conservation and the challenges they face in the wild. It's a heartwarming experience that highlights the bond between humans and elephants and the efforts to ensure their survival.",
        "imageUrl": [
          { "url": "/assets/recommended/elephantbreeding1.jpeg", "id": 1 },
          // { "url": "/assets/recommended/elephantbreeding2.webp", "id": 2 }
        ]
      },
      {
        "id": 3,
        "place": "Canoe Ride",
        "description": "Enjoy a peaceful canoe ride on the Rapti River, where you can spot crocodiles and a variety of bird species. The canoe ride offers a serene way to explore the waterways of Chitwan National Park, gliding quietly along the river and providing excellent opportunities for wildlife observation. As you paddle through the calm waters, you might see gharials and marsh mugger crocodiles sunbathing on the riverbanks or catch glimpses of vibrant kingfishers and other birds darting above the water. The ride is both relaxing and exhilarating, offering a different perspective of the park's diverse ecosystem.",
        "imageUrl": [
          { "url": "/assets/recommended/canoe1.jpeg", "id": 1 },
          { "url": "/assets/recommended/canoe2.jpeg", "id": 2 }
        ]
      },
      {
        "id": 4,
        "place": "Bird Watching",
        "description": "Chitwan is a paradise for bird watchers, with over 500 species of birds to observe in their natural habitat. The park's diverse ecosystems, ranging from dense forests to open grasslands and wetlands, provide ideal conditions for a wide variety of bird species. Enthusiasts can spot rare and exotic birds such as the Bengal florican, giant hornbill, and paradise flycatcher. Guided bird watching tours are available, led by knowledgeable ornithologists who can help you identify different species and understand their behaviors. It's an enriching experience for both novice and seasoned bird watchers, offering a deep connection to the avian world.",
        "imageUrl": [
          { "url": "/assets/recommended/birdwatching1.jpeg", "id": 1 },
          { "url": "/assets/recommended/birdwatching2.jpeg", "id": 2 }
        ]
      },
      {
        "id": 5,
        "place": "Tharu Village Tour",
        "description": "Explore the local culture with a tour of a Tharu village, where you can learn about the traditional way of life of the Tharu people. The Tharu are an indigenous ethnic group with a rich cultural heritage, known for their distinctive customs, traditional attire, and unique architecture. During the village tour, visitors can interact with the locals, visit traditional Tharu homes, and witness cultural performances such as the famous Tharu stick dance. The tour provides an authentic glimpse into the daily lives and traditions of the Tharu community, fostering cultural exchange and understanding. It's a fascinating experience that highlights the harmony between the Tharu people and their natural surroundings.",
        "imageUrl": [
          { "url": "/assets/recommended/tharu1.jpeg", "id": 1 },
          { "url": "/assets/recommended/tharu2.jpeg", "id": 2 }
        ]
      }
    ]
  },
  

  {
    "id": 5,
    "place": "The Annapurnas",
    "description": "Discover the majestic Annapurna mountain range, offering breathtaking trekking routes and awe-inspiring panoramas.",
    "imageUrl": "/assets/recommended/annapurna.jpeg",
    "attractions": [
      {
        "id": 1,
        "place": "Annapurna Base Camp",
        "description": "Annapurna Base Camp is a popular trekking destination that offers stunning views of the surrounding peaks and glaciers. It's a challenging trek that rewards hikers with breathtaking landscapes and a sense of accomplishment. The journey to the base camp takes you through diverse terrain, including lush forests, terraced fields, and quaint villages. As you ascend, the air becomes crisper and the scenery more dramatic, culminating in the awe-inspiring sight of Annapurna South, Hiunchuli, and Machapuchare. The base camp itself is nestled in a natural amphitheater, providing a 360-degree panorama of towering snow-capped peaks. This trek is a must for adventure enthusiasts and nature lovers.",
        "imageUrl": [
          {
            "url": "/assets/destination/annapurnabasecamp/annapurna1.jpeg",
            "id": 1
          },
          // {
          //   "url": "/assets/destination/annapurnabasecamp/annapurna2.webp",
          //   "id": 2
          // }
        ]
      },
      {
        "id": 4,
        "place": "Tilicho Lake",
        "description": "Tilicho Lake, one of the highest lakes in the world, offers a challenging trek with rewarding views of its pristine waters. The trek to Tilicho Lake is adventurous and provides a unique high-altitude experience. Trekkers navigate through rugged terrain, crossing rivers and climbing steep paths, with the landscape gradually transforming from green valleys to arid, rocky hills. The lake itself is a stunning sight, with crystal-clear blue waters set against a backdrop of towering snow-covered peaks. At an altitude of 4,919 meters, Tilicho Lake is a serene and breathtaking destination, making the arduous journey well worth the effort.",
        "imageUrl": [
          { "url": "/assets/recommended/tilicho1.jpeg", "id": 1 },
          { "url": "/assets/recommended/tilicho2.jpeg", "id": 2 }
        ]
      },
      {
        "id": 5,
        "place": "Jomsom",
        "description": "Jomsom is a gateway to the Mustang region and offers stunning landscapes and unique Tibetan culture. The area is known for its picturesque villages, monasteries, and dramatic mountain views. Located along the banks of the Kali Gandaki River, Jomsom is a bustling town that serves as a starting point for treks to Upper Mustang and Muktinath. The journey to Jomsom can be made by flight, jeep, or on foot, each providing different perspectives of the region's beauty. The town itself boasts traditional stone houses, vibrant local markets, and a backdrop of the Nilgiri and Dhaulagiri mountains. Visitors can explore nearby monasteries, interact with the local Thakali people, and enjoy the unique blend of natural beauty and cultural heritage.",
        "imageUrl": [
          // { "url": "/assets/recommended/jomsom1.webp", "id": 1 },
          { "url": "/assets/recommended/jomsom2.jpeg", "id": 2 }
        ]
      }
    ]
  },
  
  {
    "id": 6,
    "place": "Lumbini",
    "description": "Experience the serene ambiance of Lumbini, the birthplace of Lord Buddha, and immerse yourself in the spiritual essence of this sacred pilgrimage site.",
    "imageUrl": "/assets/recommended/lumbini.jpeg",
    "attractions": [
      {
        "id": 1,
        "place": "Maya Devi Temple",
        "description": "The Maya Devi Temple is the exact birthplace of Lord Buddha and a central pilgrimage site in Lumbini. This sacred temple stands as a testament to the profound historical and spiritual significance of Lumbini. Enclosed within a tranquil park, the temple houses the Marker Stone, pinpointing the exact location of Buddha's birth, and the Nativity Sculpture, depicting the scene of his birth. Surrounding the temple are ancient ruins of stupas and monasteries, reflecting centuries of reverence. The serene atmosphere of the Maya Devi Temple, combined with the echoes of ancient chants and the presence of pilgrims from around the world, creates a deeply moving experience for all visitors.",
        "imageUrl": [
          { "url": "/assets/recommended/mayadevi1.jpeg", "id": 1 },
          // { "url": "/assets/recommended/mayadevi2.webp", "id": 2 }
        ]
      },
      {
        "id": 2,
        "place": "Lumbini Monastic Site",
        "description": "The Monastic Site in Lumbini features numerous monasteries built by Buddhist communities from around the world. This area showcases a stunning array of architectural styles and spiritual traditions, with each monastery reflecting the culture and artistry of its home country. Visitors can explore the serene gardens, meditation centers, and intricate murals within these monasteries. The Monastic Site is a living testament to the global impact of Buddhism and provides a unique opportunity for visitors to experience a diverse range of Buddhist practices and philosophies. Whether you are a devotee or a curious traveler, the Lumbini Monastic Site offers a peaceful and enlightening journey through the heart of Buddhist spirituality.",
        "imageUrl": [
          { "url": "/assets/recommended/lumbinimonasticsites1.jpeg", "id": 1 },
          { "url": "/assets/recommended/lumbinimonasticsites2.jpeg", "id": 2 }
        ]
      },
      {
        "id": 3,
        "place": "World Peace Pagoda",
        "description": "The World Peace Pagoda in Lumbini is a symbol of peace and tranquility, offering serene surroundings and a beautiful setting. Built by the Japanese Buddhist organization Nipponzan Myohoji, the pagoda is one of many similar structures around the world dedicated to promoting peace. Surrounded by lush gardens and a reflective pond, the World Peace Pagoda provides a perfect setting for meditation and contemplation. The gleaming white structure, with its golden spire and peaceful ambiance, invites visitors to reflect on the universal message of peace and harmony. The pagoda's serene environment, combined with its spiritual significance, makes it a must-visit site for those seeking solace and inspiration.",
        "imageUrl": [
          { "url": "/assets/recommended/wordpeace1.jpeg", "id": 1 },
          { "url": "/assets/recommended/wordpeace2.jpeg", "id": 2 }
        ]
      }
    ]
  },
  
  {
    id: 7,
    place: "Nagarkot",
    description:
      "Enjoy breathtaking views of the Himalayas from Nagarkot, a scenic hilltop destination known for its panoramic sunrise and sunset views.",
    imageUrl: "/assets/recommended/nagarkot.jpeg",
    attractions: [
      {
        id: 1,
        place: "Nagarkot View Tower",
        description:
          "Nagarkot View Tower is the highest point in Nagarkot, offering one of the best panoramic views of the Himalayan range. From here, visitors can see a stretch of peaks from Dhaulagiri in the west to Mount Everest and Kanchenjunga in the east. The view at sunrise is particularly spectacular, as the first light of day casts a golden glow over the mountains. The tower provides a 360-degree view, making it an ideal spot for photography and nature appreciation. The peaceful ambiance and the awe-inspiring vistas make it a must-visit attraction for anyone traveling to Nagarkot.",
        imageUrl: [
          { url: "/assets/recommended/nagarkotview1.jpeg", id: 1 },
          { url: "/assets/recommended/nagarkotview2.jpeg", id: 2 },
        ],
      },
      {
        id: 2,
        place: "Nagarkot Panoramic Hiking Trail",
        description:
          "The Nagarkot Panoramic Hiking Trail is a popular route for those looking to explore the natural beauty of the region on foot. The trail offers stunning views of the Himalayan range and the lush valleys below. Hikers can enjoy the fresh mountain air, vibrant flora, and the chance to encounter local wildlife. The trail is well-marked and caters to hikers of all levels, providing a peaceful and invigorating outdoor experience. Whether you are an avid hiker or just looking for a leisurely walk, the panoramic hiking trail in Nagarkot is sure to leave you rejuvenated and inspired.",
        imageUrl: [
          { url: "/assets/recommended/panromic1.jpeg", id: 1 },
          { url: "/assets/recommended/panoramic2.jpeg", id: 2 },
        ],
      },
      {
        id: 3,
        place: "Changunarayan Temple",
        description:
          "Located a short drive from Nagarkot, the Changunarayan Temple is one of Nepal's oldest Hindu temples and a UNESCO World Heritage Site. The temple is dedicated to Lord Vishnu and features intricate carvings, sculptures, and inscriptions that date back to the 5th century. It is a prime example of traditional Nepalese architecture and offers rich cultural and historical insights. Visitors can explore the temple complex, admire the ancient art, and learn about the religious significance of the site. The Changunarayan Temple is not only a place of worship but also a testament to Nepal's rich cultural heritage and architectural prowess.",
        imageUrl: [
          { url: "/assets/recommended/changunarayan1.jpeg", id: 1 },
          { url: "/assets/recommended/changunarayan2.jpeg", id: 2 },
        ],
      },
    ],
  },

  {
    id: 8,
    place: "Bandipur",
    description:
      "Nestled atop a ridge in the Tanahun District, Bandipur is a charming hilltop town that has preserved its centuries-old cultural heritage",
    imageUrl: "/assets/recommended/bandipur.jpeg",
    attractions: [
      {
        id: 1,
        place: "Bindabasini Temple",
        description:
          "Perched on a hill overlooking Bandipur, Bindabasini Temple is a significant cultural and religious site. Dedicated to the goddess Bindabasini, the temple is a place of worship and a vantage point offering breathtaking views of the surrounding landscapes. The temple is an excellent example of Newari architecture, with intricate wood carvings and traditional pagoda-style design. Visitors can witness local rituals and ceremonies, gaining insight into the spiritual life of the community. The serene atmosphere and panoramic vistas make it a must-visit attraction for anyone exploring Bandipur.",
        imageUrl: [
          { url: "/assets/recommended/bindabasini1.jpeg", id: 1 },
          { url: "/assets/recommended/bindabasini2.jpeg", id: 2 },
        ],
      },
      {
        id: 5,
        place: "Bandipur Bazaar",
        description:
          "The heart of Bandipur is its bustling bazaar, a lively market area where visitors can immerse themselves in the local culture. The bazaar is lined with well-preserved buildings showcasing traditional Newari architecture, complete with ornate windows and carved wooden doors. Here, you can sample delicious local cuisine, browse for handmade crafts and souvenirs, and interact with friendly locals. The vibrant atmosphere of Bandipur Bazaar, with its mix of sights, sounds, and aromas, offers a unique and memorable experience. It's the perfect place to get a taste of daily life in Bandipur and to appreciate the town's rich cultural heritage.",
        imageUrl: [
          // { url: "/assets/recommended/bandipur1.webp", id: 1 },
          { url: "/assets/recommended/bandipur.jpeg", id: 2 },
        ],
      },
    ],
  },
];
